import React from "react"
import { useLocation } from "react-router-dom"
import { Button } from "../../components/common/button/Button"
import { Seperator } from "../../components/common/seperator/seperator"
import VehicleInfoContainer from "../../components/common/VehicleInfoContainer/VehicleInfoContainer"
import { checkPath } from '../../utils/validation-utils'

const ValuationsLimit: React.FC = () => {
  const { search } = useLocation()
  return (
    <div className="your-details-container">
      <VehicleInfoContainer />
      <div className="inner-container">
        <h2 className="contact-details-heading">
          Maximum valuation limit reached
        </h2>
        <p className="contact-details-paragraph">
          Sorry we can&apos;t provide an instant valuation. You have now
          exceeded your daily limit, please try again tomorrow.
        </p>
        <Seperator />
        <div>
          <Button
            onClick={() => window.location.replace(`/click-and-sell${checkPath(search)}`)}
            variant="blue"
          >
            BACK TO HOMEPAGE
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ValuationsLimit
